
import { useEffect } from 'react';

interface SchemaOrgProps {
  schema: object;
  id?: string;
}

const SchemaOrg = ({ schema, id = 'schema-org' }: SchemaOrgProps) => {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [schema, id]);

  return null;
};

export default SchemaOrg;
